var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1251 0.25L14 1.12502L7.37502 7.75L0.750032 1.12502L1.62505 0.250002L7.37502 5.99997L13.1251 0.25Z",
    fill: "#34485C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNotification);
export default __webpack_public_path__ + "static/media/arrow-notification.0e91895b8df2dadb9c0438ce3902a96a.svg";
export { ForwardRef as ReactComponent };